import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { BooleanFormatterWithCSS, DataGrid } from '../../components'
import * as rest from '../../services'
import { OrganizationRightsTable } from './OrganizationRightsTable'
import * as components from "../../components";

const UserRightsTable = ({ rights, onChange }) => {
  const actionFormatter = (cell, row) => {
    if (!row.url) {
      return ''
    }

    return (
      <ReactBootstrap.Button
        style={{ padding: '0px', margin: '0px', textAlign: 'right' }}
        variant="link"
        className="btn text-dark"
        onClick={(e) => {
          e.stopPropagation()
          let url = row.is_active
            ? `${row.url}deactivate/`
            : `${row.url}activate/`
          new rest.UserRightsService(url).makePostRequest().then((res) => {
            onChange()
          })
        }}
      >
        {row.is_active
          ? 'Deactivate All Organization Rights'
          : 'Activate all Requested Rights'}
      </ReactBootstrap.Button>
    )
  }

  const columns = [
    {
      dataField: 'organization_name',
      text: 'Organization',
    },
    {
      dataField: 'organization_code',
      text: 'Code',
    },
    {
      dataField: 'is_active',
      text: 'Status',
      formatter: BooleanFormatterWithCSS('is_active', 'text-left'),
    },
    {
      dataField: 'is_active',
      text: '',
      formatter: actionFormatter,
    },
       {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
  ]

  return (
    <>
      {rights && rights.length ? (
        <DataGrid
          expandRow={{
            renderer: (row) => (
              <OrganizationRightsTable
                onChange={onChange}
                userOrganizationRight={row}
              />
            ),
          }}
          keyField={'url'}
          data={rights}
          adminMode={1}
          sizePerPage={rights.length || 10}
          page={1}
          columns={columns}
          count={rights.length || 0}
        />
      ) : (
        <ReactBootstrap.Alert variant="danger">
          No Record found.
        </ReactBootstrap.Alert>
      )}
    </>
  )
}

export default UserRightsTable
